// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"a5a10e90","787":"0e6c8f6c","925":"1f97189a"}[chunkId] + ".chunk.js";
};